module.exports = __webpack_public_path__ + "assets/img/424b7d49a46142e1c2e3233931795ff5.svg";